import { REDUCERS } from '@/constants/reducers';

export function preferences(state, action) {
    switch (action.type) {
        case REDUCERS.UPDATE_PREFERENCES:
            const preferences = { ...state.preferences, ...action.payload };
            localStorage.setItem('af--preferences', JSON.stringify(preferences));
            return { ...state, preferences };
        case REDUCERS.GET_PREFERENCES:
            return { ...state, preferences };
        default:
            return state;
    }
}
